import { EXCELLENT_SCORE, MINIMUM_QUALIFYING_SCORE } from '@/marketing/models/creatorScore';

/** Shortlisting guide shown under creator lists so reviewers see the cutoff without opening a score. */
export function CreatorScoreCutoffLegend() {
  return (
    <div
      role="note"
      aria-label="Creator score guide"
      className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-1 tw-px-8 tw-pb-4 tw-text-xs tw-text-muted-foreground"
    >
      <span className="tw-font-semibold tw-text-foreground">Creator score guide</span>
      <span>
        Minimum qualifying: <strong className="tw-text-foreground">{MINIMUM_QUALIFYING_SCORE.toFixed(1)}</strong> / 10
      </span>
      <span>
        Excellent: <strong className="tw-text-foreground">{EXCELLENT_SCORE.toFixed(1)}+</strong>
      </span>
      <span>Blocked creators are fixed at 0.5</span>
      <span>Creators with no campaign history score low regardless of content; review them manually</span>
    </div>
  );
}
